import { useRef, useCallback } from 'react';

export const useScroll = () => {
  const containerNodeRef = useRef<Element | null>(null);

  const handleSetContainerNode = useCallback((node: Element | null) => {
    containerNodeRef.current = node;
  }, []);

  const handleScrollToBottom = useCallback(() => {
    const callback = () => {
      const containerNode = containerNodeRef.current;
      if (!containerNode) return;

      containerNode.scrollTop = containerNode.scrollHeight;
    };

    return setTimeout(() => callback(), 10);
  }, [containerNodeRef]);

  return {
    scrollToBottom: handleScrollToBottom,
    setContainerNode: handleSetContainerNode,
  };
};
